import { render, staticRenderFns } from "./StudentEducationalEnvPage.vue?vue&type=template&id=50525468&"
import script from "./StudentEducationalEnvPage.vue?vue&type=script&lang=ts&"
export * from "./StudentEducationalEnvPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports